import isEmpty from 'lodash.isempty';
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import ComponentWithPopover from '../../../components/componentWithPopopver/ComponentWithPopover';
import Section from './Section';
import ActivityLink from '../../activities/ActivityLink';
import './TabsSection.scss';
import { generateReactKey } from '../../../utils/shared/commonUtils';
import { getActivityIdFromUrl } from '../../../utils/shared/instructionUtils';

const TabsSection = ({
    title,
    infoText,
    tabs,
    lrsLanguageConsiderationPdf,
    switchLanguageConsiderationsTabLrs,
    lrsGroup,
}) => {
    const [activeTab, setActiveTab] = useState(0);

    const popoverRef = React.createRef();

    const handleOnBlur = () => {
        if (popoverRef.current) popoverRef.current.hide();
    };

    const tabsHeaders = [];
    const tabsViews = [];

    const lrsTrackingEventHandler = url => {
        lrsLanguageConsiderationPdf({
            title: title.slice(0, -1),
            activityId: getActivityIdFromUrl(url),
            group: lrsGroup,
        });
    };

    const handleTabClick = (index, header) => {
        setActiveTab(index);
        switchLanguageConsiderationsTabLrs(header, lrsGroup);
    };

    if (!isEmpty(tabs)) {
        tabs.forEach(({ className, itemClassName, items = [], header }, index) => {
            tabsHeaders.push(
                <div
                    className={`tab-header ${index === activeTab ? 'active' : ''}`}
                    key={generateReactKey(index)}
                    onClick={() => handleTabClick(index, header)}
                    role="tab"
                    tabIndex={0}
                >
                    {header}
                </div>,
            );

            tabsViews.push(
                <Section
                    className={`${className} tab-section ${index === activeTab ? 'active' : ''}`}
                    key={generateReactKey(index)}
                    itemClassName={itemClassName}
                    items={items.map((item, itemIndex) => (
                        <ReactMarkdown
                            key={generateReactKey(itemIndex)}
                            target="blank"
                            components={{
                                a: ({ children, href }) => {
                                    const id = getActivityIdFromUrl(href);
                                    return (
                                        <ActivityLink
                                            id={id}
                                            url={href}
                                            content={children}
                                            onClick={() => lrsTrackingEventHandler(href)}
                                        />
                                    );
                                },
                            }}
                        >
                            {item}
                        </ReactMarkdown>
                    ))}
                />,
            );
        });
    }

    return (
        <div className="tabs-section-block">
            {!isEmpty(title) && (
                <h3 className="tabs-section-title" tabIndex={-1} onBlur={handleOnBlur}>
                    {title}
                    <ComponentWithPopover
                        title="What does this mean?"
                        message={<ReactMarkdown>{infoText}</ReactMarkdown>}
                        className="nav-popover"
                        ref={popoverRef}
                    >
                        <i className="icon-amplify-info-outline pointer" />
                    </ComponentWithPopover>
                </h3>
            )}
            <div className="tabs-headers"> {tabsHeaders} </div>
            <div className="tabs-views"> {tabsViews} </div>
        </div>
    );
};

TabsSection.defaultProps = {
    title: '',
    infoText: '',
    tabs: [],
    lrsLanguageConsiderationPdf: () => {},
    switchLanguageConsiderationsTabLrs: () => {},
    lrsGroup: '',
};

TabsSection.propTypes = {
    title: PropTypes.string,
    infoText: PropTypes.string,
    tabs: PropTypes.array,
    lrsLanguageConsiderationPdf: PropTypes.func,
    switchLanguageConsiderationsTabLrs: PropTypes.func,
    lrsGroup: PropTypes.string,
};

export default TabsSection;
